import { gqlClient } from '@/api/graphql-client';
import estimateKeys from '@/api/queries/estimates/keyFactory';
import { graphql } from '@/gql';
import { useQuery } from '@tanstack/react-query';

const GetEstimateEmailPreviewQuery = graphql(`
  query GetEstimateEmailPreview($estimateId: ID!) {
    estimate(id: $estimateId) {
      id
      emailPreview {
        fromLine
        subject
      }
    }
  }
`);

const useGetEstimateEmailPreview = (estimateId?: string) => {
  const { data, ...rest } = useQuery({
    enabled: !!estimateId,
    queryKey: estimateKeys.emailPreview(estimateId),
    queryFn: () =>
      gqlClient.request(GetEstimateEmailPreviewQuery, {
        estimateId: estimateId!,
      }),
    meta: { errorMessage: 'Failed to load email preview' },
  });

  return { emailPreview: data?.estimate?.emailPreview, ...rest };
};

export default useGetEstimateEmailPreview;
